module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_j_erythristic.6acdf616.png";